import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Ayuda } from '../../../services/ayudas.service';

@Component({
    selector: 'app-delete-ayuda-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    templateUrl: './delete-ayuda-dialog.component.html',
    styleUrl: './delete-ayuda-dialog.component.scss',
})
export class DeleteAyudaDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DeleteAyudaDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { ayuda: Ayuda }
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
